import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';

// ============================================================================
// WARTUNGSMODUS AKTIV
// ----------------------------------------------------------------------------
// Alle Routen führen zur Wartungsseite. Header, Footer, WhatsApp-Button und
// Cookie-Banner sind ausgeblendet, damit keine Behandlungs-/Buchungs-Links
// angeklickt werden können.
//
// Zum Deaktivieren: diese Datei aus `App.maintenance.js` (Backup) wieder-
// herstellen ODER `MAINTENANCE_MODE` unten auf `false` setzen und den
// alten Routen-Block wieder einbinden.
// ============================================================================

import MaintenancePage from './pages/MaintenancePage';

import './App.css';

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          {/* Catch-all: jede URL zeigt die Wartungsseite */}
          <Route path="*" element={<MaintenancePage />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
